// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type SlackListsCreateResponse = SlackAPIResponse & {
  error?: string;
  list_id?: string;
  list_metadata?: ListMetadata;
  needed?: string;
  ok: boolean;
  provided?: string;
  warning?: string;
};

export interface ListMetadata {
  schema?: Schema[];
  subtask_schema?: SubtaskSchema[];
}

export interface Schema {
  id?: string;
  is_primary_column?: boolean;
  key?: string;
  name?: string;
  options?: SchemaOptions;
  type?: string;
}

export interface SchemaOptions {
  choices?: Choice[];
  format?: string;
  show_member_name?: boolean;
}

export interface Choice {
  color?: string;
  label?: string;
  value?: string;
}

export interface SubtaskSchema {
  id?: string;
  is_primary_column?: boolean;
  key?: string;
  name?: string;
  options?: SubtaskSchemaOptions;
  type?: string;
}

export interface SubtaskSchemaOptions {
  format?: string;
  show_member_name?: boolean;
}
